import { queryOptions } from '@tanstack/react-query';

import { env } from '@/config/env';

import * as supabaseSource from './tax.api';

const source = (): Promise<Pick<typeof supabaseSource, 'getImportTaxSettings'>> =>
  env.useMockData ? import('./mock') : Promise.resolve(supabaseSource);

export const taxKeys = { settings: () => ['tax', 'settings'] as const };

export const importTaxSettingsQuery = () =>
  queryOptions({
    queryKey: taxKeys.settings(),
    queryFn: async () => (await source()).getImportTaxSettings(),
    // Rates change rarely; a visitor never needs them re-fetched mid-visit.
    staleTime: 60 * 60 * 1000,
    retry: 1,
  });
